import { IonIcon } from '@ionic/react'
import { useStore, useStoreMap } from 'effector-react'
import {
  closeCircleOutline,
  chevronForward,
  bagHandleOutline,
} from 'ionicons/icons'
import { driverModel } from '~/entities/Driver'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { pushFx } from '~/shared/lib/history'
import { formatPhoneNumber } from '~/shared/lib/utils'
import { DrawerComponent } from '~/shared/ui/Drawer'
import {
  BusinessUserIcon,
  CarSimpleIcon,
  PhoneIcon,
  DocumentsIcon,
} from '~/shared/ui/icons'
import { myPalette } from '~/shared/ui/theme'
import { Card, IonIconWrapper, Title, TitleWrapper } from './styled'

type TabsDrawerProps = {
  isShow: boolean
  onClose: () => void
  onEmailClick: () => void
  onPassportDetailsClick: () => void
  onDriverLicenseClick: () => void
  onDriverDeletionDetailsClick: () => void
  onIndividualEntrepreneurClick: () => void
}

export function TabsDrawer({
  isShow,
  onClose,
  onEmailClick,
  onPassportDetailsClick,
  onDriverLicenseClick,
  onDriverDeletionDetailsClick,
  onIndividualEntrepreneurClick,
}: TabsDrawerProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const driverIsLead = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getIsLead(),
  )
  const driverTaxiparkId = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getMainTaxiparkId(),
  )

  const phone = useStoreMap(driverModel.$driver, (profile) =>
    profile?.getPhone(),
  )
  const email = useStoreMap(driverModel.$driver, (profile) =>
    profile?.getEmail(),
  )

  const handleGoToFullRegistration = () => {
    onClose()
    pushFx(`/registration?taxiparkId=${driverTaxiparkId}`)
  }

  const handleGoToDriverOccupations = () => {
    onClose()
    pushFx(`/driver-occupations`)
  }

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      {driverIsLead && (
        <Card onClick={handleGoToFullRegistration}>
          <TitleWrapper>
            <Title
              style={{
                fontSize: '14px',
                margin: 0,
                color: myPalette.coral.main,
              }}
            >
              Для просмотра всей информации пройдите полную регистрацию
            </Title>
          </TitleWrapper>
          <IonIcon
            icon={chevronForward}
            style={{
              width: '20px',
              height: '20px',
            }}
          />
        </Card>
      )}
      <Card>
        <TitleWrapper>
          <PhoneIcon />
          <a
            href={`tel:+${phone}`}
            style={{
              marginLeft: '12px',
              textDecoration: 'none',
            }}
          >
            <Title style={{ marginLeft: 0 }} data-testid='driver-phone'>
              {formatPhoneNumber(phone)}
            </Title>
          </a>
        </TitleWrapper>
      </Card>

      {!driverIsLead && (
        <>
          <Card onClick={onEmailClick}>
            <TitleWrapper>
              <BusinessUserIcon />
              <Title data-testid='tab-driver-email'>
                {email || 'Электронная почта'}
              </Title>
            </TitleWrapper>
            <IonIcon
              icon={chevronForward}
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          </Card>
          <Card onClick={onPassportDetailsClick}>
            <TitleWrapper>
              <BusinessUserIcon />
              <Title>Паспортные данные</Title>
            </TitleWrapper>
            <IonIcon
              icon={chevronForward}
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          </Card>
          <Card onClick={onDriverLicenseClick}>
            <TitleWrapper>
              <CarSimpleIcon />
              <Title>Водительские права</Title>
            </TitleWrapper>
            <IonIcon
              icon={chevronForward}
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          </Card>
          {featureFlags.driver_occupations && (
            <Card onClick={onIndividualEntrepreneurClick}>
              <TitleWrapper>
                <IonIconWrapper>
                  <IonIcon
                    icon={bagHandleOutline}
                    style={{
                      width: '20px',
                      height: '20px',
                      color: myPalette.white.main,
                    }}
                  />
                </IonIconWrapper>
                <Title>ИП</Title>
              </TitleWrapper>
              <IonIcon
                icon={chevronForward}
                style={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </Card>
          )}
          {featureFlags.driver_occupations && (
            <Card onClick={handleGoToDriverOccupations}>
              <TitleWrapper>
                <DocumentsIcon />
                <Title>Тип занятости</Title>
              </TitleWrapper>
              <IonIcon
                icon={chevronForward}
                style={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </Card>
          )}
        </>
      )}
      <Card onClick={onDriverDeletionDetailsClick}>
        <TitleWrapper>
          <IonIcon
            icon={closeCircleOutline}
            style={{
              color: myPalette.coral.main,
              width: '40px',
              height: '40px',
            }}
          />
          <Title>Удаление аккаунта</Title>
        </TitleWrapper>
        <IonIcon
          icon={chevronForward}
          style={{
            width: '20px',
            height: '20px',
          }}
        />
      </Card>
    </DrawerComponent>
  )
}
